import React from "react";
import classNames from "classnames";

import classes from "./VisualIcon.module.scss";

export interface VisualIconProps extends React.HTMLAttributes<HTMLDivElement> {
   children: React.ReactElement;
}

const VisualIcon: React.FC<VisualIconProps> = ({
   className,
   children,
   ...props
}) => {
   return (
      <div className={classNames(classes.iconContainer, className)} {...props}>
         <svg
            className={classes.iconBackground}
            xmlns="http://www.w3.org/2000/svg"
            width="114"
            height="114"
            viewBox="0 0 114 114"
            fill="none"
         >
            <path
               d="M47.8687 2.92225C53.4233 -0.680249 60.5767 -0.680249 66.1313 2.92225C69.0988 4.84689 72.5986 5.78466 76.1309 5.60164C82.7426 5.25907 88.9377 8.83581 91.9468 14.7329C93.5545 17.8835 96.1165 20.4455 99.2671 22.0532C105.164 25.0623 108.741 31.2574 108.398 37.8691C108.215 41.4014 109.153 44.9012 111.078 47.8687C114.68 53.4233 114.68 60.5767 111.078 66.1313C109.153 69.0988 108.215 72.5986 108.398 76.1309C108.741 82.7426 105.164 88.9377 99.2671 91.9468C96.1165 93.5545 93.5545 96.1165 91.9468 99.2671C88.9377 105.164 82.7426 108.741 76.1309 108.398C72.5986 108.215 69.0988 109.153 66.1313 111.078C60.5767 114.68 53.4233 114.68 47.8687 111.078C44.9012 109.153 41.4014 108.215 37.8691 108.398C31.2574 108.741 25.0623 105.164 22.0532 99.2671C20.4455 96.1165 17.8835 93.5545 14.7329 91.9468C8.83581 88.9377 5.25907 82.7426 5.60164 76.1309C5.78466 72.5986 4.84689 69.0988 2.92225 66.1313C-0.680249 60.5767 -0.680249 53.4233 2.92225 47.8687C4.84689 44.9012 5.78466 41.4014 5.60164 37.8691C5.25907 31.2574 8.83581 25.0623 14.7329 22.0532C17.8835 20.4455 20.4455 17.8835 22.0532 14.7329C25.0623 8.83581 31.2574 5.25907 37.8691 5.60164C41.4014 5.78466 44.9012 4.84689 47.8687 2.92225Z"
               fill="currentColor"
               fillOpacity="0.2"
            />
         </svg>
         <div className={classes.iconCircle}>
            {React.cloneElement(children, { className: classes.icon })}
         </div>
      </div>
   );
};

export default VisualIcon;
